import { useState } from 'react';
import PropTypes from 'prop-types';

import Dropzone from 'react-dropzone';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import FileUploadIcon from '@mui/icons-material/FileUpload';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';


const FileDropZone = ({ file, setFile, formErrors }) => {
  const defaultState = {
    icon: <FileUploadIcon sx={{ fontSize: '60px' }} />,
    text: <b>Drag 'n' drop <span style={{ color: '#0369a1' }}>docx</span> file here or click to select file</b>,
    subText: '',
    backgroundColor: '#fff',
    borderColor: '#779bbe',
  };
  const errorState = {
    icon: <ErrorOutlineOutlinedIcon sx={{ color: '#B91C1C', fontSize: '60px' }} />,
    subText: "Invalid file - drag 'n' drop or click to replace",
    backgroundColor: '#fff1f2',
    borderColor: '#B91C1C',
  };
  const successState = {
    icon: <CheckCircleOutlinedIcon sx={{ color: '#34D399', fontSize: '60px' }} />,
    subText: "File ready - drag 'n' drop or click to replace",
    backgroundColor: '#ecfdf5',
    borderColor: '#34D399',
  };
  const [fileUploadStatus, setFileUploadStatus] = useState(defaultState);

  const validateFile = sfile => {
    if (sfile.length === 1) {
      const filename = sfile[0].name;
      if (filename) {
        if (filename.split('.').slice(-1).pop() === 'docx') {
          setFile(sfile[0]);
          successState.text = filename;
          setFileUploadStatus(successState);
        } else {
          errorState.text = 'Please upload a docx file';
          setFileUploadStatus(errorState);
        }
      } else {
        errorState.text = 'File upload error. Please upload a valid docx file';
        setFileUploadStatus(errorState);
      }
    } else {
      errorState.text = 'File upload error. Please upload a single docx file';
      setFileUploadStatus(errorState);
    }
  };

  return (
    <Grid size={{ xs: 12 }}>
      <Box
        sx={{
          height: 200,
          border: (
            (!file && 'file' in formErrors) ? '2px dashed #d32f2f' : '2px dashed #cbd5e1'
          ),
          borderRadius: 3,
          textAlign: 'center',
          cursor: 'pointer',
          backgroundColor: fileUploadStatus?.backgroundColor,
          '&:hover': {
            borderColor: fileUploadStatus?.borderColor,
            boxShadow: 3,
          },
        }}
      >
        <Dropzone onDrop={acceptedFiles => validateFile(acceptedFiles)}>
          {({ getRootProps, getInputProps }) => (
            <section style={{ marginTop: '40px' }}>
              <div {...getRootProps()}>
                <input {...getInputProps()} />
                {fileUploadStatus?.icon}
                <Typography sx={{ fontSize: 18 }}>
                  <strong>{fileUploadStatus?.text}</strong>
                </Typography>
                <Typography color='text.secondary'>
                  {fileUploadStatus?.subText}
                </Typography>
              </div>
            </section>
          )}
        </Dropzone>
      </Box>
      {
        (!file && 'file' in formErrors) &&
        <p style={{ color: '#d32f2f', fontSize: '12px' }}>{formErrors?.file}</p>
      }
    </Grid>
  );
};

FileDropZone.propTypes = {
  file: PropTypes.object,
  setFile: PropTypes.func.isRequired,
  formErrors: PropTypes.object.isRequired,
};

export default FileDropZone;